import type { FormContext } from 'vee-validate'
import { ZodError } from 'zod'

export function useFormErrorHandler(form: FormContext | FormContext['setErrors']) {
  const notify = useNotify()

  return (e: unknown) => {
    if (isTRPCClientError(e) && !!e.data?.validation) {
      const zodError = new ZodError(e.data.validation)
      const { fieldErrors } = zodError.flatten()
      if (Object.keys(fieldErrors)) {
        if (typeof form === 'function') {
          form(fieldErrors)
        }
        else {
          form.setErrors(fieldErrors)
        }
      }
    }
    else {
      if (isTRPCClientError(e)) {
        if (e.data?.code === 'INTERNAL_SERVER_ERROR') {
          notify.error({
            title: 'Errore interno del server',
          })
        }
      }
      else {
        notify.error({
          title: 'Errore connessione',
        })
      }
    }
  }
}
